import {
  TEAM_NAVBAR_LINKS_V2,
  shouldShowTeamNavbarLink,
} from "@/components/navigation/TeamNavbar.constants";
import { useFlagsV2 } from "@/utils/hooks/use-flags-grpc";
import { useDANGEROUSisChalkEmployee } from "@/utils/hooks/use-is-chalk-employee";
import { useMemo } from "react";

export const useTeamNavbarLinks = () => {
  const flagsV2 = useFlagsV2();
  const canSeeAdminLinks = useDANGEROUSisChalkEmployee();

  return useMemo(
    () =>
      TEAM_NAVBAR_LINKS_V2.filter((link) =>
        shouldShowTeamNavbarLink(link, flagsV2.enabled.bind(flagsV2), canSeeAdminLinks),
      ),
    [canSeeAdminLinks, flagsV2],
  );
};
